<template>
  <div class="animated fadeInRight repair-ledger-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card" style="margin-bottom: 10px">
          <div class="card-body">
            <el-row :gutter="20" style="margin-bottom: 0">
              	<el-col :xs="12" :sm="8" :md="6" :lg="5" :xl="4">
							<el-input v-model.trim="conditions.orderNo"
								:placeholder="$t('repairPoolManage.workOrderCodePlaceholder')" clearable />
						</el-col>
						<el-col :xs="12" :sm="8" :md="6" :lg="5" :xl="4">
							<el-input v-model.trim="conditions.initiatorName"
								:placeholder="$t('repairPoolManage.repairPersonPlaceholder')" clearable />
						</el-col>
                <el-col  :sm="8" :md="6" :lg="5" :xl="4">
              <el-input
                v-model="conditions.initiatorPhone"
                placeholder="请输入手机号"
                clearable
              />
            </el-col>
              <el-col :span="6">
                <el-button type="primary" @click="queryData">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="resetQuery">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
                <el-button
                  type="success"
                  @click="exportData"
                  :loading="exporting"
                >
                  <i class="el-icon-download"></i> 导出
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div class="table-container" v-loading="loading">
            <el-table
              :data="repairList"
              border
              style="width: 100%"
              :header-cell-style="{ background: '#F5F7FA', color: '#606266' }"
              :max-height="tableHeight"
            >
              <el-table-column
                prop="orderNo"
                label="工单编号"
                align="center"
                width="200"
                fixed
              >
              </el-table-column>
              <el-table-column
                prop="communityName"
                label="小区名称"
                align="center"
                width="120"
              />

              <el-table-column label="维修地点" align="center" min-width="200">
                <template slot-scope="scope">
                  {{ getLocationText(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="itemName"
                label="维修专业"
                align="center"
                min-width="120"
              />
              <el-table-column
                prop="problemDesc"
                label="问题描述"
                align="center"
                min-width="200"
                show-overflow-tooltip
              />
              <el-table-column
                prop="initiatorName"
                label="报修人"
                align="center"
                width="200"
              />
              <el-table-column
                prop="createTime"
                label="报修时间"
                align="center"
                width="200"
              />
              <el-table-column
                label="项目部建议维修方案"
                align="center"
                width="200"
              >
                <template slot-scope="scope">
                  {{ getCanRepairText(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="资金来源" align="center" width="200">
                <template slot-scope="scope">
                  {{ getFundSourceText(scope.row) }}
                </template>
              </el-table-column>
              <!-- 	<el-table-column label="供应商报价" align="center" min-width="120">
								<template slot-scope="scope">
									{{ getSupplierNames(scope.row) }}
								</template>
							</el-table-column> -->
              <el-table-column label="报价" align="center" width="200">
                <template slot-scope="scope">
                  {{ getQuoteAmount(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="审核控制价" align="center" width="200">
                <template slot-scope="scope">
                  {{ getAuditControlPrice(scope.row) }}
                </template>
              </el-table-column>
              <!-- <el-table-column label="维修经办责任人" align="center" width="130">
								<template slot-scope="scope">
									<div v-if="getHandlerSignImage(scope.row)">
										<el-image :src="getHandlerSignImage(scope.row)"
											:preview-src-list="[getHandlerSignImage(scope.row)]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
									<span v-else>-</span>
								</template>
							</el-table-column> -->
              <el-table-column
                label="维修实施单位"
                align="center"
                min-width="200"
              >
                <template slot-scope="scope">
                  {{ getSupplierNames(scope.row) }}
                </template>
              </el-table-column>

              <el-table-column
                label="审批验收意见"
                align="center"
                :width="signColumnWidth"
              >
                <template slot-scope="scope">
                  <div
                    v-if="getSignList(scope.row).length > 0"
                    class="sign-list"
                  >
                    <div
                      v-for="(sign, idx) in getSignList(scope.row)"
                      :key="idx"
                      class="sign-item"
                    >
                      <div class="sign-info">{{ sign.roleName }}意见</div>
                      <el-image
                        :src="sign.img"
                        :preview-src-list="getSignImgList(scope.row)"
                        fit="contain"
                        class="sign-image"
                      />
                    </div>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column label="维修进度" align="center" width="200">
                <template slot-scope="scope">
                  <el-tag :type="getProgressTagType(scope.row)" size="small">
                    {{ getRepairProgress(scope.row) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="维修前水印照片"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <div
                    class="image-cell"
                    v-if="getImageList(scope.row.problemImgs).length > 0"
                  >
                    <el-image
                      v-for="(img, idx) in getImageList(
                        scope.row.problemImgs
                      ).slice(0, 3)"
                      :key="idx"
                      :src="img"
                      :preview-src-list="getImageList(scope.row.problemImgs)"
                      fit="cover"
                      class="table-image"
                    />
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column
                label="维修中水印照片"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <div
                    class="image-cell"
                    v-if="getProcessImages(scope.row).length > 0"
                  >
                    <el-image
                      v-for="(img, idx) in getProcessImages(scope.row).slice(
                        0,
                        3
                      )"
                      :key="idx"
                      :src="img"
                      :preview-src-list="getProcessImages(scope.row)"
                      fit="cover"
                      class="table-image"
                    />
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column
                label="维修后水印照片"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <div
                    class="image-cell"
                    v-if="getImageList(scope.row.repairAfterImgs).length > 0"
                  >
                    <el-image
                      v-for="(img, idx) in getImageList(
                        scope.row.repairAfterImgs
                      ).slice(0, 3)"
                      :key="idx"
                      :src="img"
                      :preview-src-list="
                        getImageList(scope.row.repairAfterImgs)
                      "
                      fit="cover"
                      class="table-image"
                    />
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              
              <el-table-column label="维修实际费用" align="center" width="120">
                <template slot-scope="scope">
                  {{ getActualRepairFee(scope.row) }}
                </template>
              </el-table-column>

              <el-table-column label="支付状态" align="center" width="100">
                <template slot-scope="scope">
                  {{ getPayStatusText(scope.row) }}
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="margin-top: 20px"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getCommunityId, getStoreName } from '@/api/community/communityApi';
  import request from '@/utils/request';

  export default {
    name: 'RepairLedgerList',
    data() {
      return {
        loading: false,
        exporting: false,
        repairList: [],
        conditions: {
          initiatorName: '',
          orderNo: '',
					initiatorPhone:''
        },
        page: {
          current: 1,
          size: 10,
          total: 0,
        },
        currentRoleKey: '',
        currentRoleRelCd: '',
        tableHeight: 600,
      };
    },
    created() {
      this.fetchData();
    },
    mounted() {
      this.calcTableHeight();
      window.addEventListener('resize', this.calcTableHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.calcTableHeight);
    },
    computed: {
      // 签名列宽度：根据最大签名数量和最长角色名计算
      signColumnWidth() {
        let maxCount = 0;
        let maxRoleLen = 0;
        this.repairList.forEach((row) => {
          const signList = this.getSignList(row);

          if (signList.length > maxCount) {
            maxCount = signList.length;
          }
          signList.forEach((sign) => {
            if (sign.roleName && sign.roleName.length > maxRoleLen) {
              maxRoleLen = sign.roleName.length;
            }
          });
        });
        const countWidth = maxCount * 120;
        const nameWidth = maxRoleLen * 20;
        return Math.max(countWidth, nameWidth * maxCount, 120);
      },
    },
    methods: {
      calcTableHeight() {
        this.$nextTick(() => {
          const tableEl = document.querySelector('.table-container');
          if (tableEl) {
            const rect = tableEl.getBoundingClientRect();
            const viewHeight = window.innerHeight;
            this.tableHeight = viewHeight - rect.top - 120;
          }
        });
      },
      // 查询所有工单（新接口）
      async queryAllOrders(params) {
        const response = await request({
          url: '/app/pms.queryAllOrder',
          method: 'get',
          params,
        });
        const res = response.data;
        if (res.code === 0) {
          return {
            data: res.data || [],
            total: res.total || res.records || 0,
          };
        } else {
          throw new Error(res.msg || '查询失败');
        }
      },

      async fetchData() {
        this.loading = true;
        try {
          const params = {
            ...this.conditions,
            communityId: getCommunityId(),
            page: this.page.current,
            row: this.page.size,
          };

          // 过滤空值参数
          Object.keys(params).forEach((key) => {
            if (params[key] === '') {
              delete params[key];
            }
          });

          const res = await this.queryAllOrders(params);
          const repairList = res.data || [];
          repairList.forEach((item) => {
            item.materialList = JSON.parse(item.materialList);
          });

          this.repairList = repairList;
          this.page.total = res.total || 0;
        } catch (error) {
          console.error('查询维修台账失败:', error);
          this.$message.error('查询失败，请稍后重试');
        } finally {
          this.loading = false;
        }
      },
      formatDate(date) {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },

      // 获取报修类型文本
      getOrderTypeText(orderType) {
        const typeMap = {
          0: '室内报修',
          1: '公区报修',
        };
        return typeMap[String(orderType)] || '-';
      },

      // 获取是否能修文本
      getCanRepairText(row) {
        if (!row.materialList) {
          return '-';
        }
        try {
          const list = typeof row.materialList === 'string'
            ? JSON.parse(row.materialList)
            : row.materialList;
          if (Array.isArray(list) && list.length > 0) {
              return list[0].constructionPlan ||list[1].constructionPlan||'-';
          }
          return '-';
        } catch (e) {
          return '-';
        }
      },

      // 获取资金来源文本（是否外委）
      getFundSourceText(row) {
        // 优先取 supplierInf 中的 responsibilityRemark
        if (row.supplierInfo) {
          try {
            const supplierData = typeof row.supplierInfo === 'string'
              ? JSON.parse(row.supplierInfo)
              : row.supplierInfo;
            if (supplierData.responsibilityRemark) {
              return supplierData.responsibilityRemark;
            }
          } catch (e) {
            console.error('解析supplierInfo失败', e);
          }
        }

        var isOutsource = row.isOutsource;
       
        if (isOutsource === null || isOutsource === undefined) {
          return '-';
        }
        const fundSourceMap = {
          1: '物业修理范围',
          2: '不是物业修理范围',
        };
        return fundSourceMap[String(isOutsource)] || '-';
      },

      // 获取位置文本
      getLocationText(row) {
        if (!row) return '-';

        // 如果是公区报修（orderType === 1），使用 addressDetail
        if (row.orderType === 1 || row.orderType === '1') {
          return row.addressDetail || '-';
        }
        // 如果是室内报修（orderType === 0），组合楼栋-单元-房号
        else if (row.orderType === 0 || row.orderType === '0') {
          const building = row.floorNum || row.buildingNum || '';
          const unit = row.unitNum || '';
          const room = row.roomNum || row.roomName || '';

          if (building || unit || room) {
            let location = '';
            if (building) location += `${building}栋`;
            if (unit) location += `${unit}单元`;
            if (room) location += room;
            return location || row.roomName || '-';
          }

          return row.roomName || '-';
        }

        return row.addressDetail || row.roomName || '-';
      },

      // 获取图片列表
      getImageList(imgStr) {
        if (!imgStr) return [];
        try {
          // 如果是数组直接返回
          if (Array.isArray(imgStr)) {
            return imgStr.filter((img) => img);
          }
          // 如果是JSON字符串，解析后返回
          if (typeof imgStr === 'string') {
            // 尝试JSON解析
            try {
              const parsed = JSON.parse(imgStr);
              if (parsed) {
                var arr = parsed.images.split(',');
                return Array.isArray(arr) ? arr : [];
              }
            } catch (e) {
              // 如果不是JSON，按逗号分割
              return imgStr.split(',').filter((img) => img && img.trim());
            }
          }
          return [];
        } catch (error) {
          console.error('解析图片列表失败:', error);
          return [];
        }
      },

      // 获取供应商名
      getSupplierNames(row) {
        if (!row) return '-';

        // 如果有 supplierInfo 字段（JSON字符串或对象） supplierInfo
        if (row.supplierInfo) {
          try {
            let supplierInfo = row.supplierInfo;
            if (typeof supplierInfo === 'string') {
              supplierInfo = JSON.parse(supplierInfo);
            }

            // 如果有suppliers数组，获取contactName
            if (supplierInfo.suppliers && supplierInfo.suppliers.length > 0) {
              const contactNames = supplierInfo.suppliers
                .map((item) => item.name || '')
                .filter((name) => name);
              if (contactNames.length > 0) {
                return contactNames.join('，');
              }
            }

            if (Array.isArray(supplierInfo) && supplierInfo.length > 0) {
              const names = supplierInfo
                .map((item) => item.name || '')
                .filter((name) => name);
              if (names.length > 0) {
                return names.join('，');
              }
            } else if (supplierInfo && supplierInfo.name) {
              return supplierInfo.name;
            }
          } catch (e) {
            console.log('解析供应商信息失败', e);
          }
        }

        // 如果有单独的 supplierName 字段
        if (row.supplierName) {
          return row.supplierName;
        }

        const storeName = getStoreName();
        return storeName.includes('公司') ? storeName : storeName + '公司自修';
      },

      // 获取报价金额
      getQuoteAmount(row) {
        if (!row) return '-';

        // 如果有 quoteInfo 字段（JSON字符串）
        if (row.quoteInfo) {
          try {
            let quoteData = row.quoteInfo;
            if (typeof quoteData === 'string') {
              quoteData = JSON.parse(quoteData);
            }

            if (quoteData.num) {
              return quoteData.num;
            }
          } catch (e) {
            console.error('解析报价信息失败:', e);
          }
        }

        // 如果有单独的 quoteAmount 字段
        if (row.quoteAmount) {
          return row.quoteAmount;
        }

        return '-';
      },

      // 获取审核控制
      getAuditControlPrice(row) {
        if (!row) return '-';

        // 如果有 auditControl 字段（JSON字符串）
        if (row.auditControl) {
          try {
            let auditData = row.auditControl;
            if (typeof auditData === 'string') {
              auditData = JSON.parse(auditData);
            }

            if (auditData.controlNum) {
              return auditData.controlNum;
            }
          } catch (e) {
            console.error('解析审核控制价失败', e);
          }
        }

        // 如果有单独的 auditControlPrice 字段
        if (row.auditControlPrice) {
          return row.auditControlPrice;
        }

        return '-';
      },

      // 获取维修实际费用（与审核控制价比较取小值，两者需大于0）
      getActualRepairFee(row) {
        if (!row) return '-';

        const repairFee = row.repairMaterialFee;
        if (repairFee === null || repairFee === undefined || repairFee === '') {
          return '-';
        }

        const auditPrice = this.getAuditControlPrice(row);
        if (auditPrice === '-') {
          return repairFee;
        }

        const numRepairFee = Number(repairFee);
        const numAuditPrice = Number(auditPrice);

        // 两个值都不能小于或等于0，否则不比较直接返回维修费用
        if (numRepairFee <= 0 || numAuditPrice <= 0) {
          return repairFee;
        }

        return Math.min(numRepairFee, numAuditPrice);
      },

      // 获取维修中图片（特殊处理JSON格式
      getProcessImages(row) {
        if (!row || !row.repairProcessImgs) return [];

        try {
          let imgData = row.repairProcessImgs;

          // 如果是字符串，尝试解析
          if (typeof imgData === 'string') {
            // 尝试解析为JSON对象
            try {
              const parsed = JSON.parse(imgData);
              // 如果解析后有 images 字段
              if (parsed.images) {
                if (typeof parsed.images === 'string') {
                  return parsed.images.split(',');
                } else if (Array.isArray(parsed.images)) {
                  return parsed.images.filter((img) => img);
                }
              }
              // 如果解析后是数组
              if (Array.isArray(parsed)) {
                return parsed.filter((img) => img);
              }
            } catch (e) {
              // 如果不是JSON，按逗号分割
              return imgData.split(',').filter((img) => img && img.trim());
            }
          }

          // 如果是数组直接返回
          if (Array.isArray(imgData)) {
            return imgData.filter((img) => img);
          }

          return [];
        } catch (error) {
          console.error('解析维修中图片失败', error);
          return [];
        }
      },

      // 解析签名信息
      parseSignPics(row) {
        if (!row || !row.signPics) return [];

        try {
          let signData = row.signPics;
          if (typeof signData === 'string') {
            signData = JSON.parse(signData);
          }

          if (Array.isArray(signData)) {
            var signList = [];
            signData.forEach((item) => {
              if (typeof item === 'string') {
                var tt = JSON.parse(item);
                // console.log(tt)
                signList.push(tt);
              } else {
                signList.push(item);
              }
            });

            return signList;
          }

          return [];
        } catch (error) {
          console.error('解析签名信息失败:', error);
          return [];
        }
      },

      // 获取部门审核意见（roleId: 5 - 部门负责人）
      getDeptAuditOpinion(row) {
        const signList = this.parseSignPics(row);
        const deptSign = signList.find((s) => String(s.roleId) === '5');

        if (deptSign && deptSign.img) {
          return '已同意';
        }

        return '-';
      },

      // 获取部门签名图片
      getDeptSignImage(row) {
        const signList = this.parseSignPics(row);
        const deptSign = signList.find((s) => String(s.roleId) === '5');
        return deptSign && deptSign.img ? deptSign.img : null;
      },

      // 获取维修岗签名图片（roleId: 4 - 维修岗负责人
      getHandlerSignImage(row) {
        const signList = this.parseSignPics(row);
        const handlerSign = signList.find((s) => String(s.roleId) === '4');
        return handlerSign && handlerSign.img ? handlerSign.img : null;
      },

      // 获取分管领导审核意见（roleId: 9 - 分管领导
      getLeaderAuditOpinion(row) {
        const signList = this.parseSignPics(row);
        const leaderSign = signList.find((s) => String(s.roleId) === '9');

        if (leaderSign && leaderSign.img) {
          return '已同意';
        }

        return '-';
      },

      // 获取分管领导签名图片
      getLeaderSignImage(row) {
        const signList = this.parseSignPics(row);
        const leaderSign = signList.find((s) => String(s.roleId) === '9');
        return leaderSign && leaderSign.img ? leaderSign.img : null;
      },

      // 获取总（副总）经理审核意见（roleId: 2 - 总经理 / roleId: 10 - 董事长）
      getManagerAuditOpinion(row) {
        const signList = this.parseSignPics(row);
        const managerSign = signList.find(
          (s) => String(s.roleId) === '2' || String(s.roleId) === '10'
        );

        if (managerSign && managerSign.img) {
          return '已同意';
        }

        return '-';
      },

      // 获取总（副总）经理签名图片
      getManagerSignImage(row, name) {
        const signList = this.parseSignPics(row);
        const managerSign = signList.find((s) =>
          String(s.roleName).includes(name)
        );
        return managerSign && managerSign.img ? managerSign.img : null;
      },

      // 获取支付状态文
      getPayStatusText(row) {
        var payStatus = row.payStatus;
        if (row.orderType === 1) {
          //公区报修
          return '-';
        }

        if (payStatus === null || payStatus === undefined) {
          return '-';
        }
        const statusMap = {
          0: '未支付',
          1: '待支付',
          2: '已支付',
        };
        return statusMap[String(payStatus)] || '-';
      },

      // 格式化状态名
      formatStatusName(status) {
        const statusMap = {
          0: '待接单',
          1: '待派工',
          2: '待处理',
          3: '处理中',
          4: '待验收',
          5: '已完成',
          6: '已驳回',
          7: '已关闭',
          8: '已取消',
        };
        return statusMap[String(status)] || '-';
      },

      // 根据角色名称获取审核签名图片
      getAuditSignImage(row, roleName) {
        const signList = this.parseSignPics(row);
        const sign = signList.find((s) => s.roleName === roleName);
        return sign && sign.img ? sign.img : null;
      },

      // 获取所有签名图片
      getAllSignImages(row) {
        const signList = this.parseSignPics(row);
        return signList.filter((s) => s.img).map((s) => s.img);
      },

      // 获取签名对象列表（包含角色名称和图片，按px字段排序）
      getSignList(row) {
        const signList = this.parseSignPics(row);
        //console.log('signList', signList)
        const filtered = signList.filter((s) => s.img);

        // 按px字段从小到大排序，如果没有px字段保持原顺序
        return filtered.sort((a, b) => {
          const pxA = a.px !== undefined && a.px !== null ? a.px : Infinity;
          const pxB = b.px !== undefined && b.px !== null ? b.px : Infinity;
          return pxA - pxB;
        });
      },

      // 获取所有签名图片URL列表（用于预览）
      getSignImgList(row) {
        return this.getSignList(row).map((s) => s.img);
      },

      // 获取维修进度（根据图片判断）
      getRepairProgress(row) {
        if (!row) return '待维修';

        // 如果有验收图片（维修后图片），状态为已完成
        const afterImages = this.getImageList(row.repairAfterImgs);
        if (afterImages.length > 0) {
          return '已完成';
        }

        // 如果有维修中图片，状态为维修中
        const processImages = this.getProcessImages(row);
        if (processImages.length > 0) {
          return '维修中';
        }

        // 否则为待维修
        return '待维修';
      },

      // 获取维修进度 tag 类型
      getProgressTagType(row) {
        if (!row) return 'info';

        // 如果有验收图片（维修后图片），状态为已完成 - 绿色
        const afterImages = this.getImageList(row.repairAfterImgs);
        if (afterImages.length > 0) {
          return 'success';
        }

        // 如果有维修中图片，状态为维修中 - 蓝色
        const processImages = this.getProcessImages(row);
        if (processImages.length > 0) {
          return 'primary';
        }

        // 否则为待维修 - 橙色
        return 'warning';
      },

      // 将图片URL转为base64
      async fetchImageBase64(url) {
        if (!url) return null;
        try {
          const response = await fetch(url, { mode: 'cors' });
          if (!response.ok) return null;
          const blob = await response.blob();
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
          });
        } catch (e) {
          return null;
        }
      },

      // 导出维修台账
      async exportData() {
        this.exporting = true;
        try {
          // 获取全部数据（不分页）
          const params = {
            ...this.conditions,
            communityId: getCommunityId(),
            page: 1,
            row: 99999,
          };
          Object.keys(params).forEach((key) => {
            if (params[key] === '') {
              delete params[key];
            }
          });

          const res = await this.queryAllOrders(params);
          const allData = res.data || [];

          if (allData.length === 0) {
            this.$message.warning('没有可导出的数据');
            this.exporting = false;
            return;
          }

          // 动态导入 exceljs
          const ExcelJS = (await import('exceljs')).default;
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('维修台账');

          // 定义表头
          const headers = [
            '工单编号',
            '维修地点',
            '维修专业',
            '问题描述',
            '报修人',
            '报修时间',
            '项目部建议维修方案',
            '资金来源',
            '报价',
            '审核控制价',
            '维修实施单位',
            '领导签名',
            '维修进度',
            '维修前照片',
            '维修中照片',
            '维修后照片',
            '维修实际费用',
            '支付状态',
          ];
          const totalCols = headers.length;

          // 设置列宽
          const colWidths = [
            30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 300, 30, 100, 100, 100,
            30, 30,
          ];
          for (let i = 0; i < colWidths.length; i++) {
            worksheet.getColumn(i + 1).width = colWidths[i];
          }

          // === 标题行（第1行）===
          const titleRow = worksheet.addRow([]);
          worksheet.mergeCells(1, 1, 1, totalCols);
          titleRow.getCell(1).value = '维修台账';
          titleRow.height = 40;
          titleRow.font = { size: 24, bold: true };
          titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

          // === 表头行（第2行）===
          const headerRow = worksheet.addRow(headers);
          headerRow.height = 45;
          headerRow.font = { size: 16, bold: true };
          headerRow.alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          };

          // === 数据行（第3行起）===
          allData.forEach((row) => {
            worksheet.addRow([
              row.orderNo || '',
              this.getLocationText(row),
              row.itemName || '',
              row.problemDesc || '',
              row.initiatorName || '',
              row.createTime || '',
              this.getCanRepairText(row),
              this.getFundSourceText(row),
              this.getQuoteAmount(row),
              this.getAuditControlPrice(row),
              this.getSupplierNames(row),
              this.getSignList(row)
                .map((s) => s.roleName + '签名')
                .join('  ') || '-', // 领导签名 - 横向排列
              this.getRepairProgress(row),
              this.getImageList(row.problemImgs).length > 0 ? '' : '', // 维修前水印照片
              this.getProcessImages(row).length > 0 ? '' : '', // 维修中水印照片
              this.getImageList(row.repairAfterImgs).length > 0 ? '' : '', // 维修后水印照片
              row.repairMaterialFee || '',
              this.getPayStatusText(row),
            ]);
          });

          // 设置数据行样式：垂直居中、字体20磅，行高适配图片
          const headerRowIdx = 2;
          for (
            let i = headerRowIdx + 1;
            i <= headerRowIdx + allData.length;
            i++
          ) {
            const dataRow = worksheet.getRow(i);
            dataRow.height = 90;
            dataRow.font = { size: 14 };
            dataRow.alignment = {
              vertical: 'middle',
              horizontal: 'center',
              wrapText: true,
            };
          }

          // === 收集并嵌入图片（使用 exceljs）===
          const signCol = 11; // 领导签名列 (0-based)
          const beforeCol = 13; // 维修前水印照片列
          const processCol = 14; // 维修中水印照片列
          const afterCol = 15; // 维修后水印照片列

          const imageTasks = [];

          allData.forEach((row, rowIdx) => {
            const excelRow = rowIdx + 3; // Excel行号（1-based：标题行1，表头行2，数据从3开始）

            // 领导签名图片（记录总数和索引用于横向排列）
            const signList = this.getSignList(row);
            const signCount = signList.length;
            signList.forEach((sign, signIdx) => {
              if (sign.img) {
                imageTasks.push({
                  url: sign.img,
                  row: excelRow,
                  col: signCol,
                  index: signIdx,
                  total: signCount,
                  name: `sign_${rowIdx}_${signIdx}`,
                });
              }
            });

            // 维修前水印照片
            const beforeImgs = this.getImageList(row.problemImgs);
            beforeImgs.forEach((img, imgIdx) => {
              imageTasks.push({
                url: img,
                row: excelRow,
                col: beforeCol,
                name: `before_${rowIdx}_${imgIdx}`,
              });
            });

            // 维修中水印照片
            const processImgs = this.getProcessImages(row);
            processImgs.forEach((img, imgIdx) => {
              imageTasks.push({
                url: img,
                row: excelRow,
                col: processCol,
                name: `process_${rowIdx}_${imgIdx}`,
              });
            });

            // 维修后水印照片
            const afterImgs = this.getImageList(row.repairAfterImgs);
            afterImgs.forEach((img, imgIdx) => {
              imageTasks.push({
                url: img,
                row: excelRow,
                col: afterCol,
                name: `after_${rowIdx}_${imgIdx}`,
              });
            });
          });

          // 批量获取图片base64并通过 exceljs 嵌入
          if (imageTasks.length > 0) {
            const batchSize = 20;

            for (let i = 0; i < imageTasks.length; i += batchSize) {
              const batch = imageTasks.slice(i, i + batchSize);
              const results = await Promise.all(
                batch.map(async (task) => {
                  const base64 = await this.fetchImageBase64(task.url);
                  return { ...task, base64 };
                })
              );

              results.forEach((task) => {
                if (task.base64) {
                  try {
                    const imageId = workbook.addImage({
                      base64: task.base64,
                      extension: 'png',
                    });
                    // 签名图片横向排列：按 index/total 计算列偏移
                    let colPos = task.col;
                    let imgWidth = 120;
                    if (
                      task.total != null &&
                      task.index != null &&
                      task.total > 0
                    ) {
                      const spacing = 1 / task.total;
                      colPos = task.col + task.index * spacing;
                      imgWidth = 80;
                    }
                    worksheet.addImage(imageId, {
                      tl: { col: colPos, row: task.row - 1 },
                      ext: { width: imgWidth, height: 60 },
                    });
                  } catch (imgErr) {
                    console.warn('嵌入图片失败:', task.name, imgErr);
                  }
                }
              });
            }
          }

          // 生成并下载
          const buffer = await workbook.xlsx.writeBuffer();
          const now = new Date();
          const fileName = `维修台账_${now.getFullYear()}${String(
            now.getMonth() + 1
          ).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}.xlsx`;
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);

          this.$message.success(`导出成功，共 ${allData.length} 条记录`);
        } catch (error) {
          console.error('导出维修台账失败:', error);
          this.$message.error('导出失败，请稍后重试');
        } finally {
          this.exporting = false;
        }
      },

      queryData() {
        this.page.current = 1;
        this.fetchData();
      },
      resetQuery() {
        this.conditions = {
          initiatorName: '',
        };
        this.page.current = 1;
        this.fetchData();
      },
      handleSizeChange(val) {
        this.page.size = val;
        this.fetchData();
      },
      handleCurrentChange(val) {
        this.page.current = val;
        this.fetchData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .repair-ledger-container {
    padding: 20px;

    .box-card {
      margin-bottom: 20px;
    }

    .table-container {
      // el-table 自带滚动，不需要额外设置
    }

    // 图片单元格样式
    .image-cell {
      display: flex;
      gap: 5px;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 5px 0;
    }

    .table-image {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    .sign-list {
      display: flex;
      flex-direction: row;
      gap: 10px;
      justify-content: center;
      align-items: flex-start;
    }

    .sign-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
    }

    .sign-info {
      font-size: 11px;
      color: #666;
      white-space: nowrap;
    }

    .sign-image {
      width: 100px;
      height: 50px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
